const SITE_URL = "https://actshark.com";

const toAbsoluteUrl = (value: string) => {
  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  const path = value.startsWith("/") ? value : `/${value}`;
  return `${SITE_URL}${path}`;
};

export const seo = ({
  title,
  description,
  keywords,
  image,
  path = "/",
  robots = "index, follow",
}: {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  path?: string;
  robots?: string;
}) => {
  const absoluteUrl = toAbsoluteUrl(path);
  const absoluteImage = image ? toAbsoluteUrl(image) : undefined;
  const twitterCard = absoluteImage ? "summary_large_image" : "summary";

  return [
    { title },
    { name: "description", content: description },
    { name: "keywords", content: keywords },
    { name: "robots", content: robots },
    { name: "twitter:card", content: twitterCard },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: absoluteImage },
    { property: "og:type", content: "website" },
    { property: "og:site_name", content: "ActShark" },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:url", content: absoluteUrl },
    { property: "og:image", content: absoluteImage },
  ].filter((tag) => {
    if ("title" in tag) {
      return true;
    }

    return Boolean(tag.content);
  });
};
